//* Import libraries
import { useState, useCallback, useEffect } from "react";

//* Import react-router hooks
import { Link, useNavigate } from "react-router-dom";

//* Import components
import { List } from "../../../component/list/list";
import { Loading } from "../../../component/common/Loading";

//* Import custom hooks
import { useDemands } from "../../../hooks/demand/useDemands";

import { Demands } from "../../../hooks/demand/types/types";
import { Button, Form, Spinner, Row, Col } from "react-bootstrap";
import { Attention } from "../../../component/base/Attention";
import ModalMensagem from "../../../component/base/ModalMensagem";

var debounce = require("lodash.debounce");

export function Modularidade() {
  const token = localStorage.getItem("token") || "";

  const [answers, setAnswers]: any = useState({});

  const onchangeInput=(e:any,key:any)=>{
    if(e.target.value!='' && Number.isNaN(e.target.value)){
      return;
    }

    let answers_ = { ...answers }
    answers_[key] =e.target.value==''?'': parseInt(e.target.value)
    setAnswers(answers_)
  }



  return (
    <div className="row">
      <div className="col-12">

        <div className={"py-5 px-3"}>
          <div className={"card-body"} id="card">
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "2.0rem", color: "black" }}
            >
              Modularidade
            </h4>
            <br></br>
            <br></br>
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Explicação do critério:
            </h4>
            <br></br>
            <p align="justify"> <strong> Esse critério identifica o grau em que o software científico é composto por módulos independentes entre si. Dessa forma, é possível verificar 
              o impacto que a alteração em um módulo provocará em outros módulos e no sistema como um todo. Além disso, esse critério identifica o grau de independência entre as entradas 
              e as saídas geradas por funções diferentes, de modo que a modificação do resultado de uma função provoque mudanças mínimas em outras funções que utilizam o resultado da 
              função alterada como entrada. </strong> </p>
              <p align="justify"> <strong> Qual é o seu peso na avaliação desse critério? Digite no campo abaixo </strong> </p>
            <Form.Control
                    placeholder=""
                    style={{  }}
                    value={answers['inicial'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'inicial')
                    }}
                    required
                    
                  />
            <br></br>

            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Avaliação dos critérios:
            </h4>
            <br></br>


            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              <strong>Responsabilidade única</strong>:  O módulo ou função deve ser implementado para realizar apenas uma atividade, por mais complexa que ela seja. Assim, tudo 
              relacionado a uma atividade estará concentrado em uma única parte do código-fonte. Como essa boa prática é atendida? <Attention />
              </Form.Label>
              <div>
                 <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao1"
                                checked={answers[1] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[1] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao1"
                                checked={answers[1] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[1] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao1"
                                checked={answers[1] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[1] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao1"
                                checked={answers[1] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[1] = 4;
                                  setAnswers(answers_)
                                }}
                              />
              </div>
            </Form.Group>


            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Alta coesão: As funções presentes em um módulo devem trabalhar em conjunto o máximo possível, de forma que se relacionem com funções de outros módulos apenas 
              quando necessário. Além disso, as função presente em um módulo deve ter sempre a sua importância para o funcionamento do mesmo, de modo a evitar código-fonte 
              sem utilização. Como essa boa prática é atendida?  <Attention />
              </Form.Label>
              <div>
              <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao2"
                                checked={answers[2] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[2] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao2"
                                checked={answers[2] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[2] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao2"
                                checked={answers[2] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[2] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao2"
                                checked={answers[2] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[2] = 4;
                                  setAnswers(answers_)
                                }}
                              />

                
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Baixo acoplamento: Os módulos devem depender o mínimo possível entre si, sendo o ideal que eles se relacionem apenas por chamadas bem definidas ou 
              consumindo dados gerados e já inseridos no Banco de Dados. Como essa boa prática é atendida?  <Attention />
              </Form.Label>
              <div>
              <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao3"
                                checked={answers[3] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[3] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao3"
                                checked={answers[3] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[3] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao3"
                                checked={answers[3] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[3] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao3"
                                checked={answers[3] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[3] = 4;
                                  setAnswers(answers_)
                                }}
                              />
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Testes unitários: Desenvolver e documentar um conjunto de testes para validar o funcionamento do módulo, de forma que sempre que ocorra uma mudança no 
              módulo os testes possam ser reexecutados para garantir o seu funcionamento. Como essa boa prática é atendida? <Attention />
              </Form.Label>
              <div>
              <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao4"
                                checked={answers[4] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[4] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao4"
                                checked={answers[4] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[4] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao4"
                                checked={answers[4] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[4] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao4"
                                checked={answers[4] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[4] = 4;
                                  setAnswers(answers_)
                                }}
                              />
                </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Testes de integração: Desenvolver e documentar um conjunto de testes para validar o funcionamento das comunicações entre dois ou mais módulos, de forma que, 
              sempre que ocorra uma mudança em algum desses módulos, os testes possam ser reexecutados para garantir o funcionamento do relacionamento entre eles. 
              Como essa boa prática é atendida?  <Attention />
              </Form.Label>
              <div>
                
              <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao5"
                                checked={answers[5] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[5] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao5"
                                checked={answers[5] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[5] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao5"
                                checked={answers[5] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[5] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao5"
                                checked={answers[5] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[5] = 4;
                                  setAnswers(answers_)
                                }}
                              />
              </div>
            </Form.Group>
            <br></br>

            <button onClick={(e) => {

            }} className="btn btn-success btn-lg w-100">
              Gerar resultado
            </button>
            <ModalMensagem/>














          </div>
        </div>
      </div>

    </div>
  );
}
